import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";

export const Hero = () => {
  return (
    <section id="top" className="relative overflow-hidden grain pt-16 md:pt-24 pb-20 md:pb-32">
      <div className="blob bg-[#9B8FE0] w-[480px] h-[480px] -top-32 -right-20" />
      <div className="blob bg-[#F4B8C7] w-[420px] h-[420px] top-40 -left-32 opacity-60" />
      <div className="blob bg-[#B5C9E8] w-[360px] h-[360px] bottom-0 right-1/3 opacity-50" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="flex items-center gap-2 mb-8"
        >
          <span className="inline-flex items-center gap-2 text-base md:text-lg font-bold uppercase tracking-[0.18em] text-[#9B8FE0]">
            <Sparkles size={16} /> Préparation mentale et optimisation de la performance
          </span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-[8rem] font-black leading-[0.9] tracking-tighter max-w-5xl"
        >
          Le mental comme <span className="relative inline-block px-3 bg-[#9B8FE0] text-white -skew-x-3">vecteur</span> de la performance.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-10 max-w-2xl text-xl md:text-2xl text-zinc-600 leading-relaxed"
        >
          <strong className="text-zinc-900">Léa Mistral — Consultante en Psychologie du Sport &amp; Préparation Mentale.</strong>
          <span className="block mt-2 text-zinc-600">Spécialiste des Sciences du Sport.</span>
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.45 }}
          className="mt-12 flex flex-wrap gap-4"
        >
          <a
            href="#contact"
            data-testid="hero-cta-primary"
            className="group inline-flex items-center gap-3 bg-[#9B8FE0] hover:bg-[#8678D4] text-white font-bold py-4 px-8 rounded-full text-lg md:text-xl transition-all hover:-translate-y-1 hover:shadow-[0_12px_30px_-8px_rgba(255,79,0,0.5)]"
          >
            Réserver une séance découverte
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </a>
          <a
            href="#services"
            data-testid="hero-cta-secondary"
            className="inline-flex items-center gap-2 border-2 border-zinc-900 text-zinc-900 hover:bg-zinc-900 hover:text-white font-bold py-4 px-8 rounded-full text-lg md:text-xl transition-colors"
          >
            Découvrir les services
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.7 }}
          className="mt-20 grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-10 border-t border-black/10 pt-10"
        >
          {[
            ["100%", "personnalisé"],
            ["Accompagnement mental à distance", "individuel en distanciel · présentiel pour les groupes"],
            ["Font-Romeu", "& distanciel partout en France"],
          ].map(([n, l]) => (
            <div key={n}>
              <div className="font-display text-2xl md:text-3xl font-black text-zinc-900 leading-tight">{n}</div>
              <div className="text-lg md:text-xl text-zinc-600 mt-2 font-normal">{l}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
